export const DEFAULT_OUTSTREAM_VOLUME = 0.5;
export const DEFAULT_OUTSTREAM_REQUEST_CONTEXT_URL = 'https://tunein.com/radio/home/';
export const AD_REQUEST_RETRY_DELAY_SECONDS = 60;
export const OUTSTREAM_LOOP_STALL_THRESHOLD_MS = 600_000;
export const OUTSTREAM_VIDEO_APS_SLOT_ID = 'APS_VideoOUT_GAM';
